
export default function MeditacoesGuiadas() {
  const meditacoes = [
    {
      titulo: 'Ponte ao Futuro — Visualização Criativa',
      descricao: 'Técnica de PNL para ensaiar mentalmente o sucesso e criar uma memória futura poderosa.',
      icon: 'ri-road-map-line',
      link: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+ponte+ao+futuro+PNL+visualiza%C3%A7%C3%A3o',
      tags: ['PNL', 'Visualização', 'Futuro']
    },
    {
      titulo: 'Visualize Seu Futuro e Torne-o Realidade',
      descricao: 'Sinta os resultados das suas metas como se já tivessem acontecido. Técnica de memória futura.',
      icon: 'ri-eye-line',
      link: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+visualize+seu+futuro+torne+realidade',
      tags: ['Manifestação', 'Metas']
    },
    {
      titulo: 'Desenhando Seu Futuro — Criação Consciente',
      descricao: 'Direcione sua energia para o que deseja construir. Ideal para planejamento de novos ciclos.',
      icon: 'ri-quill-pen-line',
      link: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+desenhando+seu+futuro+cria%C3%A7%C3%A3o+consciente',
      tags: ['Criação', 'Planejamento']
    },
    {
      titulo: 'Reprogramação Mental — Dr. Joe Dispenza',
      descricao: 'Liberte o corpo de emoções do passado para criar uma nova realidade futura.',
      icon: 'ri-brain-line',
      link: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+reprograma%C3%A7%C3%A3o+mental+joe+dispenza+portugu%C3%AAs',
      tags: ['Reprogramação', 'Neurociência']
    },
    {
      titulo: 'Encontre Seu Propósito de Vida',
      descricao: 'Jornada interior para descobrir sua missão e alinhar talentos com seu verdadeiro chamado.',
      icon: 'ri-compass-3-line',
      link: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+encontrar+prop%C3%B3sito+de+vida+miss%C3%A3o',
      tags: ['Propósito', 'Missão']
    },
    {
      titulo: 'Prosperidade e Abundância Financeira',
      descricao: 'Remova bloqueios e abra-se para a prosperidade em todas as áreas da vida.',
      icon: 'ri-money-dollar-circle-line',
      link: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+prosperidade+abund%C3%A2ncia+financeira',
      tags: ['Prosperidade', 'Abundância']
    },
    {
      titulo: 'Amor e Relacionamentos Saudáveis',
      descricao: 'Cultive compaixão, cure mágoas e atraia conexões afetivas verdadeiras.',
      icon: 'ri-heart-3-line',
      link: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+amor+relacionamento+saud%C3%A1vel+atrair',
      tags: ['Amor', 'Relacionamentos']
    },
    {
      titulo: 'Saúde, Cura e Vitalidade',
      descricao: 'Escaneamento corporal, afirmações de vitalidade e visualização do corpo saudável.',
      icon: 'ri-heart-pulse-line',
      link: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+sa%C3%BAde+cura+vitalidade+corpo+saud%C3%A1vel',
      tags: ['Saúde', 'Cura']
    },
    {
      titulo: 'Alta Performance e Foco',
      descricao: 'Concentração, disciplina e mentalidade vencedora para alcançar resultados extraordinários.',
      icon: 'ri-trophy-line',
      link: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+alta+performance+foco+concentra%C3%A7%C3%A3o',
      tags: ['Performance', 'Foco']
    }
  ];

  return (
    <section className="py-24 bg-luxury-dark relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
      <div className="absolute top-40 left-0 w-80 h-80 bg-gold-500/3 rounded-full blur-[100px]"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gold-500/40"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">
              🎧 Meditações Recomendadas
            </span>
            <div className="w-12 h-px bg-gold-500/40"></div>
          </div>
          <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-white mb-4">
            Meditações Guiadas para Sua <span className="text-gold-400 italic">Jornada</span>
          </h2>
          <p className="font-['Montserrat'] text-base text-white/50 max-w-3xl mx-auto font-light tracking-wide">
            Selecionamos as melhores meditações guiadas em português para complementar cada etapa da sua transformação pessoal.
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {meditacoes.map((med, index) => (
            <a
              key={index}
              href={med.link}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group bg-white/[0.03] rounded-2xl border border-gold-500/10 hover:border-gold-500/30 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_30px_rgba(201,168,76,0.08)] cursor-pointer"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 rounded-xl bg-gold-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-gold-500/20 transition-colors">
                  <i className={`${med.icon} text-xl text-gold-400`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="font-['Playfair_Display'] text-lg font-semibold text-white group-hover:text-gold-400 transition-colors mb-1">
                    {med.titulo}
                  </h3>
                </div>
              </div>

              <p className="font-['Montserrat'] text-sm text-white/40 mb-4 leading-relaxed font-light">
                {med.descricao}
              </p>

              <div className="flex items-center justify-between">
                <div className="flex gap-2">
                  {med.tags.map((tag, i) => (
                    <span key={i} className="px-2 py-1 bg-gold-500/10 rounded-full font-['Montserrat'] text-[10px] text-gold-400/70 tracking-wider uppercase">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center gap-1.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-youtube-fill text-red-500"></i>
                  </div>
                  <i className="ri-external-link-line text-xs text-white/30 group-hover:text-gold-400 transition-colors"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Dica */}
        <div className="mt-12 bg-white/[0.03] rounded-2xl p-8 border border-gold-500/10 text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <i className="ri-lightbulb-flash-line text-2xl text-gold-400"></i>
            <h3 className="font-['Playfair_Display'] text-xl font-bold text-white">Dica de Prática</h3>
          </div>
          <p className="font-['Montserrat'] text-sm text-white/50 max-w-2xl mx-auto font-light leading-relaxed">
            Para melhores resultados, encontre um lugar tranquilo, use fones de ouvido e pratique diariamente. 
            A meditação regular ajuda a reduzir o cortisol, melhorar o sono e fortalecer a percepção corporal. 
            Combine com a escrita das suas cartas para uma experiência transformadora.
          </p>
        </div>
      </div>
    </section>
  );
}
